import memoize from 'memoizee';
import Web3 from 'web3';
import config from '@/constants/config';
// import { multiCall } from '../Calls';
import SWAP_ABI from '../../constants/abis/json/compound/swap.json';

const web3 = new Web3(config.rpcUrl);

// Contract instances cache store
const getContractInstance = memoize((address, abi) => (
    new web3.eth.Contract(abi, address)
));

const getPoolVirtualPrice = memoize(async (address) => {
    try {
        const virtualPriceUint = await getContractInstance(address, SWAP_ABI).methods.get_virtual_price().call();
        return virtualPriceUint / 1e18;
    } catch (err) {
        return 0; // Some pools get_virtual_price calls revert if pool is empty
    }
}, {
    promise: true,
    maxAge: 10 * 60 * 1000, // 10 min
});

export default getPoolVirtualPrice;
